/**
 * @description 获取证件类型
 * @param {string} str
 * @returns {string} 对应类型描述
 */
export default function getCertType(str) {
    switch (str) {
        case 'NI':
            return '身份证';
        case 'PP':
            return '护照号';
        case 'P':
            return '护照号';
        case 'ID':
            return '其他证件';
        default:
            return '身份证';
    }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getCertType.js
// module id = null
// module chunks = 